/** The storefront path of a page; the backend writes its redirects between these. */
export function pagePath(handle: string): string {
  return `/pages/${handle}`;
}
